import { FC } from 'react';
import { LocalAccountsInsights as LocalAccountsInsightsType } from '../../../types/LocalAccountsInsights';
import { Badge, LayoutCarousel, SingleMetric } from '@silverfort/sf-components';
import LocalAccountAccessTypesCard from './LocalAccountAccessTypesCard';
import LocalAccountsModeStatisticsCard from './LocalAccountsModeStatisticsCard';
import BoundAccountsStatisticsCard from './BoundAccountsStatisticsCard';

type Props = {
    localAccountsInsights?: LocalAccountsInsightsType;
    isLoading: boolean;
};

const LocalAccountsInsights: FC<Props> = ({ localAccountsInsights, isLoading }) => {
    const isNoLocalAccounts = isLoading || !localAccountsInsights?.totalLocalAccounts;

    return (
        <div className="grid grid-cols-8 grid-rows-4 gap-3 h-50">
            <div className="col-span-2 row-span-2">
                <LayoutCarousel
                    title="Local accounts"
                    contentClassName="py-0 flex flex-1 flex-col justify-center [&]:items-start"
                    pages={
                        <div className="flex flex-row gap-2 px-2">
                            {isLoading ? (
                                <div className="h-6 w-[112px] animate-pulse rounded-sm bg-sf-gray-50"></div>
                            ) : (
                                <span className="text-[21px]/[24px] font-bold font-sf-poppins">
                                    {isNoLocalAccounts
                                        ? '0'
                                        : localAccountsInsights?.totalLocalAccounts.toLocaleString()}
                                </span>
                            )}
                            <Badge
                                color="secondary"
                                text="Total"
                                customClassNames={
                                    isNoLocalAccounts ? { text: 'text-sf-gray-300', background: 'bg-sf-gray-50' } : {}
                                }
                            />
                        </div>
                    }
                />
            </div>

            <div className="row-span-2 col-start-1 row-start-3 font-sf-poppins h-full">
                <SingleMetric
                    title="Active local accounts"
                    value={localAccountsInsights?.activeLocalAccounts || 0}
                    isLoading={isLoading}
                    titleClassName="block leading-[16px]"
                />
            </div>

            <div className="row-span-2 col-start-2 row-start-3 font-sf-poppins h-full">
                <SingleMetric
                    title="Inactive local accounts"
                    value={localAccountsInsights?.inactiveLocalAccounts || 0}
                    isLoading={isLoading}
                    titleClassName="block leading-[16px]"
                />
            </div>

            <div className="col-span-2 row-span-4 col-start-3 row-start-1">
                <LocalAccountAccessTypesCard localAccountsInsights={localAccountsInsights} isLoading={isLoading} />
            </div>

            <div className="col-span-2 row-span-4 col-start-5 row-start-1">
                <LocalAccountsModeStatisticsCard localAccountsInsights={localAccountsInsights} isLoading={isLoading} />
            </div>

            <div className="col-span-2 row-span-4 col-start-7 row-start-1">
                <BoundAccountsStatisticsCard localAccountsInsights={localAccountsInsights} isLoading={isLoading} />
            </div>
        </div>
    );
};

export default LocalAccountsInsights;
